import { Switch, Text, Flex, Image } from "@chakra-ui/react";
import { formatMoney } from "infra/helpers/number";

interface CardProviderProps {
  nome: string;
  imagemUrl: string;
  valor: number;
  id: string;
  value: boolean;
  onChange: (state: boolean) => void;
}

function CardProvider(props: CardProviderProps) {
  return (
    <Flex
      maxW={"max(33%, 200px)"}
      position="relative"
      borderRadius="8px"
      borderWidth="1px"
      borderColor={"#D0D0D0"}
      h="120px"
    >
      <Flex flex={1} alignItems="center" justifyContent="end">
        <Flex flex={1} flexDir="column" alignItems="center">
          {props.imagemUrl ? (
            <Image src={props.imagemUrl} w="40px" h="40px" />
          ) : null}
          <Text fontSize="13px" mt="4px">
            {props.nome}
          </Text>
          {props.valor ? (
            <Text fontSize="10px" mt="2px">
              {formatMoney(props.valor)} por mensagem
            </Text>
          ) : null}
        </Flex>
      </Flex>
      <Flex pos="absolute" right={2} top={2}>
        <Switch
          mt="10px"
          mr="10px"
          isChecked={!!props.value}
          onChange={() => {
            props.onChange(!props.value);
          }}
        />
      </Flex>
    </Flex>
  );
}

export default CardProvider;
